import useTableColumns from './useTableColumns'
import useHeaderBtns from './useHeaderBtns'
import useAffiliationGroupItems from './useAffiliationGroupItems'

export default { useHeaderBtns, useAffiliationGroupItems, useTableColumns }